(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1403],{

/***/ 23433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CategorySmallBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
//@ts-nocheck






// import 'slick-carousel/slick/slick.css'


// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
function SampleNextArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/right-icon-black.svg",
            alt: "RightArrow"
        })
    });
}
function SamplePrevArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/icon/left-icon-black.svg",
            alt: "LeftArrow"
        })
    });
}
function CategorySmallBanner(param) {
    var categoryData = param.categoryData, scrollY = param.scrollY, handleClose = param.handleClose, pathname = param.pathname;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 12,
        slidesToScroll: 1,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: "40px"
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "book-application-shop-by-category-small-banner-alignment ".concat(scrollY >= 100 ? "open-nav-alignment" : "hide-nav-alignment"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            style: {
                padding: 0
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "book-application-shop-by-category-small-banner-flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "book-application-shop-by-category-option",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, settings), {
                        children: categoryData === null || categoryData === void 0 ? void 0 : categoryData.map(function(cat, index) {
                            var ref, ref1, ref2;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "book-application-shop-by-category-link-alignment",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: "".concat(pathname, "/").concat(cat === null || cat === void 0 ? void 0 : cat.slug),
                                        scroll: false,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === (cat === null || cat === void 0 ? void 0 : (ref2 = cat.slug) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) ? "menu-active" : "",
                                            children: cat === null || cat === void 0 ? void 0 : cat.name
                                        })
                                    })
                                }, index)
                            });
                        })
                    }))
                })
            })
        })
    });
}


/***/ }),

/***/ 89681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductListView; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/assets/icon/moreOptionIconsc.svg
/* harmony default export */ var moreOptionIconsc = ({"src":"/_next/static/media/moreOptionIconsc.5562bdd7.svg","height":15,"width":25});
// EXTERNAL MODULE: ./src/store/slices/mobileModalSlice.tsx
var mobileModalSlice = __webpack_require__(64965);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/store.tsx + 6 modules
var store = __webpack_require__(74573);
;// CONCATENATED MODULE: ./src/components/ProductPage/TabProduct/ProductListView.tsx







function ProductListView(param) {
    var products = param.products, color = param.color, stateForWidth = param.stateForWidth;
    var stopMovie = function(e) {
        e.target.pause();
    };
    var playMovie = function(e) {
        e.target.play();
    };
    var fetchMobileModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageMobileModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    var dispatch = (0,store/* useAppDispatch */.T)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row findYourStyle_mobile-view-list-details-alignment",
            style: {
                backgroundColor: color
            },
            children: products === null || products === void 0 ? void 0 : products.map(function(product, index) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fondYourStyle_mobile-view-list-box",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fondYourStyle_img-alignment",
                            children: (product === null || product === void 0 ? void 0 : product.images) && ((ref = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.src) === null || ref1 === void 0 ? void 0 : ref1.includes("mp4")) || (product === null || product === void 0 ? void 0 : product.images) && ((ref2 = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.src) === null || ref3 === void 0 ? void 0 : ref3.includes("mov")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                loop: true,
                                autoPlay: true,
                                onMouseOver: playMovie,
                                onMouseOut: stopMovie,
                                poster: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: (product === null || product === void 0 ? void 0 : product.images) && ((ref4 = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref4 === void 0 ? void 0 : ref4.src),
                                    type: "video/mp4"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (product === null || product === void 0 ? void 0 : product.images) && ((ref5 = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref5 === void 0 ? void 0 : ref5.src)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fondYourStyle_listView-details-alignment",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: (product === null || product === void 0 ? void 0 : (ref6 = product.title) === null || ref6 === void 0 ? void 0 : ref6.length) > 30 ? (product === null || product === void 0 ? void 0 : product.title.substring(0, 30)) + "..." : product === null || product === void 0 ? void 0 : product.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "listView-details_product-child-details-alignment",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "listView-details_product-proce-discount-alignment",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "$ ",
                                                            (product === null || product === void 0 ? void 0 : product.dis_price) ? product === null || product === void 0 ? void 0 : product.dis_price : product === null || product === void 0 ? void 0 : (ref7 = product.inventoryPrice) === null || ref7 === void 0 ? void 0 : ref7.price
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            (product === null || product === void 0 ? void 0 : product.dis_listPrice) || (product === null || product === void 0 ? void 0 : (ref8 = product.inventoryPrice) === null || ref8 === void 0 ? void 0 : ref8.listPrice) ? "$" : "",
                                                            (product === null || product === void 0 ? void 0 : product.dis_listPrice) ? product === null || product === void 0 ? void 0 : product.dis_listPrice : product === null || product === void 0 ? void 0 : (ref9 = product.inventoryPrice) === null || ref9 === void 0 ? void 0 : ref9.listPrice
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "listView-details_findYourStyle-list-details-alignment",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mobile-men-sub-category-list-card_utils",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mobile-men-sub-category-list-box",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "14",
                                                        height: "15",
                                                        viewBox: "0 0 14 15",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M7.09102 11.5061L7.09057 11.5061C7.06785 11.5279 7.04378 11.5482 7.01851 11.5669L4.9283 13.1154C4.70086 13.2839 4.39793 13.31 4.14503 13.1829C3.89212 13.0558 3.73232 12.7971 3.73184 12.514L3.73013 11.5061H2.72877C1.941 11.5061 1.2496 10.8855 1.2496 10.0561V4.7C1.2496 3.87062 1.941 3.25 2.72877 3.25H11.4788C12.2666 3.25 12.958 3.87062 12.958 4.7V10.0561C12.958 10.8855 12.2666 11.5061 11.4788 11.5061H7.09102Z",
                                                            stroke: "#ACB1C0",
                                                            strokeWidth: "1.5",
                                                            strokeLinejoin: "round"
                                                        })
                                                    }),
                                                    (product === null || product === void 0 ? void 0 : product.like_count) || 0
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mobile-men-sub-category-list-box",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "14",
                                                        height: "14",
                                                        viewBox: "0 0 14 14",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M6.99967 3.39334L5.92439 2.28777L5.79518 2.15492L6.86677 1.11268L5.79518 2.15492C4.94587 1.28169 3.5797 1.28169 2.73039 2.15492C1.86721 3.04241 1.86721 4.49157 2.73039 5.37906L6.99967 9.76859L11.269 5.37906C12.1321 4.49157 12.1321 3.04241 11.269 2.15492C10.4197 1.28169 9.05348 1.28169 8.20417 2.15492L7.18346 1.16217L8.20417 2.15492L8.07496 2.28777L6.99967 3.39334ZM6.16334 11.0601L1.6551 6.42488C0.225643 4.95517 0.225643 2.57881 1.6551 1.10909C3.01628 -0.290425 5.18402 -0.365448 6.63167 0.884023C6.71367 0.954797 6.79336 1.02982 6.87046 1.10909L6.99967 1.24194L7.12889 1.10909C7.20599 1.02982 7.28568 0.954797 7.36768 0.884023C8.81533 -0.365448 10.9831 -0.290425 12.3442 1.10909C13.7737 2.57881 13.7737 4.95517 12.3442 6.42488L7.83601 11.0601C7.38677 11.522 6.64815 11.5323 6.18625 11.083C6.17472 11.0717 6.17469 11.0717 6.16342 11.0602L6.16334 11.0601ZM7.23858 10.0142L7.23857 10.0142L7.23858 10.0142Z",
                                                            fill: "#ACB1C0"
                                                        })
                                                    }),
                                                    (product === null || product === void 0 ? void 0 : product.comment_count) || 0
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mobile-men-sub-category-list-box",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                        width: "14",
                                                        height: "14",
                                                        viewBox: "0 0 14 14",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M10.5 4.66797C11.4665 4.66797 12.25 3.88447 12.25 2.91797C12.25 1.95147 11.4665 1.16797 10.5 1.16797C9.5335 1.16797 8.75 1.95147 8.75 2.91797C8.75 3.88447 9.5335 4.66797 10.5 4.66797Z",
                                                                stroke: "#ACB1C0",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M3.5 8.75C4.4665 8.75 5.25 7.9665 5.25 7C5.25 6.0335 4.4665 5.25 3.5 5.25C2.5335 5.25 1.75 6.0335 1.75 7C1.75 7.9665 2.5335 8.75 3.5 8.75Z",
                                                                stroke: "#ACB1C0",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M10.5 12.832C11.4665 12.832 12.25 12.0485 12.25 11.082C12.25 10.1155 11.4665 9.33203 10.5 9.33203C9.5335 9.33203 8.75 10.1155 8.75 11.082C8.75 12.0485 9.5335 12.832 10.5 12.832Z",
                                                                stroke: "#ACB1C0",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M5.01074 7.87891L8.99491 10.2006",
                                                                stroke: "#ACB1C0",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M8.98908 3.79688L5.01074 6.11854",
                                                                stroke: "#ACB1C0",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    }),
                                                    (product === null || product === void 0 ? void 0 : product.sharepost_count) || 0
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "listView-details_moreOption-alignment",
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        dispatch((0,mobileModalSlice/* fetchMobileModalData */.B)({
                                            allModalData: (0,_to_consumable_array/* default */.Z)((fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData) ? fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.allModalData : []).concat([
                                                {
                                                    modal: "productOption",
                                                    isOpen: true,
                                                    id: product,
                                                    transform: 508
                                                }, 
                                            ]),
                                            lastModalData: fetchMobileModal === null || fetchMobileModal === void 0 ? void 0 : fetchMobileModal.lastModalData
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: moreOptionIconsc.src,
                                        alt: "MoreOptionIcon"
                                    })
                                })
                            ]
                        })
                    ]
                }, index);
            })
        })
    });
}


/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);